import {
  Settings,
  Github,
  List,
  PlayCircle,
  Copy,
  Download,
  Share2,
  RefreshCw,
  HelpCircle,
  Plus,
  Trash2,
  Check,
  Code2,
  AlertTriangle,
  Loader2,
  Moon,
  Sun,
  Info,
  ArrowLeft,
  Video,
  Globe,
  Package,
  Monitor,
  Headphones,
  ExternalLink,
  Coffee,
  MessageSquare,
  ThumbsUp,
  ThumbsDown,
  X,
  Send,
  ShieldCheck,
  Activity,
  AlertCircle,
  Mail,
  Menu,
  Lock,
  Zap,
} from 'lucide-react';

export const Icons = {
  Settings,
  Github,
  List,
  Play: PlayCircle,
  Copy,
  Download,
  Share: Share2,
  Refresh: RefreshCw,
  Help: HelpCircle,
  Plus,
  Trash: Trash2,
  Check,
  Code: Code2,
  Warning: AlertTriangle,
  Spinner: Loader2,
  Loader: Loader2,
  Moon,
  Sun,
  Info,
  ArrowLeft,
  Video,
  Globe,
  Package,
  Monitor,
  Headphones,
  ExternalLink,
  Coffee,
  MessageSquare,
  ThumbsUp,
  ThumbsDown,
  X,
  Send,
  ShieldCheck,
  Activity,
  AlertCircle,
  Mail,
  Menu,
  Lock,
  Zap,
};
